import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IWebSite } from "../../models/WebSite";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Emptywebsite } from "./Emptywebsite";
import { JVDropdown } from "../../shared/JVDropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";
import { JVTime } from "../../shared/JVTime";
import { format } from "date-fns";

const schema = yup.object({
    description: yup.string(),
    setting_Value: yup.string().required("Record Person/Page is required").nullable(),
    experience_In: yup.string().required("Experience is required").nullable(),
    experience_Total: yup.number().typeError("Total Experience should be a number").required("Total experience is required").nullable(),
    number_Of_Allocation: yup.number().typeError("No. Of Allocation should be a number").required("Number of allocation is required").nullable(),
    pV_Experience_In: yup.string().required("Experience is required").nullable(),
    pV_Experience_Duration_To: yup.number().typeError("should be a number").required("Duration is required").nullable(),
    pV_Experience_Duration_From: yup.number().required("Duration is required").typeError("should be number").nullable(),
    pV_Number_Of_Allocation: yup.number().required("Number of allocation is required").typeError("no. of allocation should be number").nullable(),
    pV_Calculation_In: yup.string().required("Calculation is required").nullable(),
    pV_Calculation_Duration: yup.number().required("calculation duration is required").typeError("should be number").nullable(),
    number_Picked_Vendor: yup.number().required("Number of Picked Vendor is required").typeError("should be number").nullable(),
    send_Unserved_Req_Mail: yup.number().required("Float Email Schedule Time is required").typeError("should be number").nullable(),
    float_Req_Gap_Time: yup.number().required("Float Email Gap Time is required").typeError("should be number").nullable(),
    no_Sub_Per_Req: yup.number().required("No of sub per  is required").typeError("should be number").nullable(),
    req_Hold_After_Sub: yup.number().required("req hold after sub  is required").typeError("should be number").nullable(),
    add_Req_Start_Time: yup.date().required("Add req start time is required").typeError("Add req start time is required").nullable(),
    add_Req_End_Time: yup.date().required("Add req end time is required").typeError("Add req end time is required").nullable(),
    allocation_Schedular_Start_Time: yup.date().required("allocation start time is required").typeError("allocation start time is required").nullable(),
    dollar_Rate: yup.number().required("Dollar Rate is Required").nullable(),
    maxConsultantSelections: yup.number().required("Max Consultant Selection is required"),
    maxEmailSendToConsultant: yup.number().required("Max Consultant Selection is required"),
    team_Lead_Margin_Team_Expenses_Percentage: yup.number().required("Team Lead Margin Percentage on Team Expenses is required"),
    // team_Lead_Margin_Dollar: yup.number().required("Team Lead Margin Dollar"),
});

interface Iprops {
    singleData: IWebSite,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}
const DropDown: { name: string }[] = [
    { name: "Days" },
    { name: "Months" },
    { name: "Years" }
];

export const Form = (props: Iprops) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IWebSite>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    const saveToDB = async (body: IWebSite) => {
        const method = props.singleData?.setting_Id ? "PUT" : "POST";
        const message = props.singleData?.setting_Id ? "Updated Successfully" : "Added Successfully";
        const resp = await Fetch("Website_Settings/updatedDollarRate", "POST", body, null, null);
        if (resp) {
            const response = await Fetch("Website_Settings", method, body, null, props.toast);
            if (response) {
                props.hideDialog();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
        };
    }

    const onHide = () => {
        props.hideDialog();
        reset(Emptywebsite);
    }

    const getSetting = async () => {
        const response = await Fetch("Website_Settings/byId", "GET", null, `Setting_Id=${props.singleData?.setting_Id}`, props.toast);
        if (response) {
            const data: IWebSite = await response.json();
            if (typeof (data.add_Req_Start_Time) === "string") {
                let timeArray = data.add_Req_Start_Time.split(" ");
                let hour = parseInt(timeArray[0].split(":")[0]);
                if (timeArray[1] === "PM") hour += 12;
                let minute = parseInt(timeArray[0].split(":")[1]);
                data.add_Req_Start_Time = new Date(0, 0, 0, hour, minute, 0);
            }
            if (typeof (data.add_Req_End_Time) === "string") {
                let timeArray = data.add_Req_End_Time.split(" ");
                let hour = parseInt(timeArray[0].split(":")[0]);
                if (timeArray[1] === "PM") hour += 12;
                let minute = parseInt(timeArray[0].split(":")[1]);
                data.add_Req_End_Time = new Date(0, 0, 0, hour, minute, 0);
            }
            if (typeof (data.allocation_Schedular_Start_Time) === "string") {
                let timeArray = data.allocation_Schedular_Start_Time.split(" ");
                let hour = parseInt(timeArray[0].split(":")[0]);
                if (timeArray[1] === "PM") hour += 12;
                let minute = parseInt(timeArray[0].split(":")[1]);
                data.allocation_Schedular_Start_Time = new Date(0, 0, 0, hour, minute, 0);
            }
            reset(data);
        }
    }
    useEffect(() => {
        if (props.singleData?.setting_Id) {
            getSetting();
        }

    }, [props.singleData]);

    function onSubmit(data: IWebSite) {
        if (data.add_Req_Start_Time !== null && data.add_Req_Start_Time !== undefined) data.add_Req_Start_Time = format(new Date(data.add_Req_Start_Time), 'hh:mm a').toUpperCase();
        if (data.add_Req_End_Time !== null && data.add_Req_End_Time !== undefined) data.add_Req_End_Time = format(new Date(data.add_Req_End_Time), 'hh:mm a').toUpperCase();
        if (data.allocation_Schedular_Start_Time !== null && data.allocation_Schedular_Start_Time !== undefined) data.allocation_Schedular_Start_Time = format(new Date(data.allocation_Schedular_Start_Time), 'hh:mm a').toUpperCase();
        saveToDB(data);
    }
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Template" modal className="p-fluid" onHide={onHide} maximizable>
            <form onSubmit={handleSubmit(onSubmit)} >
                <Accordion multiple activeIndex={[0]}>
                    <AccordionTab header="Client Contact Person Setting">
                        <div className="p-fluid formgrid grid">
                            <JVInput type="number" required label="Record Person/Page Value " control={control} name="setting_Value" error={errors.setting_Value?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Sales Allocation Setting">
                        <div className="p-fluid formgrid grid">
                            <JVDropdown required column={4} label="Experience In" control={control} name="experience_In" options={DropDown} optionLabel="name" optionValue="name" placeholder="Select Type" error={errors.experience_In?.message} />
                            <JVInput required column={4} label="Experience " control={control} name="experience_Total" error={errors.experience_Total?.message} />
                            <JVInput required type="number" column={4} label="Number Of Allocation" control={control} name="number_Of_Allocation" error={errors.number_Of_Allocation?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Prime Vendor Performance Setting">
                        <div className="p-fluid formgrid grid">
                            <JVDropdown column={4} label="Experience In" control={control} name="pV_Experience_In" options={DropDown} optionLabel="name" optionValue="name" placeholder="Select Type" error={errors.pV_Experience_In?.message} />
                            <JVInput required type="number" column={4} label="Experience From" control={control} name="pV_Experience_Duration_From" error={errors.pV_Experience_Duration_From?.message} />
                            {/* <JVInput required type="number" column={4} label="Experience To" control={control} name="pV_Experience_Duration_To" error={errors.pV_Experience_Duration_To?.message}/> */}
                            <JVInput required type="number" column={4} label="Number Of Allocation" control={control} name="pV_Number_Of_Allocation" error={errors.pV_Number_Of_Allocation?.message} />
                            <JVDropdown required column={4} label="Calculate In" control={control} name="pV_Calculation_In" options={DropDown} optionLabel="name" optionValue="name" placeholder="Select Type" error={errors.pV_Calculation_In?.message} />
                            <JVInput required type="number" column={4} label="Calculate" control={control} name="pV_Calculation_Duration" error={errors.pV_Calculation_Duration?.message} />
                            <JVInput required type="number" column={4} label="Number Of Picked Vendor" control={control} name="number_Picked_Vendor" error={errors.number_Picked_Vendor?.message} />
                            <JVInput required type="number" column={4} label="Notification time (in minutes)" control={control} name="notification_Time" error={errors.notification_Time?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Requirement Float Setting">
                        <div className="p-fluid formgrid grid">
                            <JVInput required type="number" column={4} label="Float Requirement Time (in minutes)" control={control} name="send_Unserved_Req_Mail" error={errors.send_Unserved_Req_Mail?.message} />
                            <JVInput required type="number" column={4} label="Float Requirement Gap Time (in minutes)" control={control} name="float_Req_Gap_Time" error={errors.float_Req_Gap_Time?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Submission Setting">
                        <div className="p-fluid formgrid grid">
                            <JVInput required type="number" column={4} label="Max sub on req" control={control} name="no_Sub_Per_Req" error={errors.no_Sub_Per_Req?.message} />
                            <JVInput required type="number" column={4} label="Req hold after sub" control={control} name="req_Hold_After_Sub" error={errors.req_Hold_After_Sub?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Allocation Schedular Setting">
                        <div className="p-fluid formgrid grid">
                            <JVTime column={3} label="Allocation Script Schedular Time" required control={control} name="allocation_Schedular_Start_Time" error={errors.add_Req_Start_Time?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Add Requirement Setting">
                        <div className="p-fluid formgrid grid">
                            <JVTime column={3} label="Add Requirement Start Time" required control={control} name="add_Req_Start_Time" error={errors.add_Req_Start_Time?.message} />
                            <JVTime column={3} label="Add Requirement End Time" required control={control} name="add_Req_End_Time" error={errors.add_Req_End_Time?.message} />
                            <div style={{ margin: '10px 0', width: '100%' }}></div>
                            <JVCheckbox column={3} label="Enable Requirement Post Time" control={control} name="enable_Add_Req_Time" />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Testing Email Setting">
                        <div className="p-fluid formgrid grid">
                            <div style={{ margin: '10px 0', width: '100%' }}></div>
                            <JVCheckbox column={3} label="Enable Testing Email" control={control} name="enable_Testing_Email" />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Dollar Rate">
                        <div className="p-fluid formgrid grid">
                            <div style={{ margin: '10px 0', width: '100%' }}></div>
                            <JVInput required type="number" column={4} label="Dollar Rate Time (in number)" control={control} name="dollar_Rate" error={errors.dollar_Rate?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Search Consultant Email Sending Setting">
                        <div className="p-fluid formgrid grid">
                            <div style={{ margin: '10px 0', width: '100%' }}></div>
                            <JVInput required type="number" column={4} label="Max Consultant Selections (in number)" control={control} name="maxConsultantSelections" error={errors.maxConsultantSelections?.message} />
                            <JVInput required type="number" column={4} label="Max Email Send To Consultant (in number)" control={control} name="maxEmailSendToConsultant" error={errors.maxEmailSendToConsultant?.message} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Team Lead Margin Percentage On Team Expenses">
                        <div className="p-fluid formgrid grid">
                            <div style={{ margin: '10px 0', width: '100%' }}></div>
                            <JVInput required type="number" column={2} label="Team Lead Margin Percentage On Team Expenses (in number only)" control={control} name="team_Lead_Margin_Team_Expenses_Percentage" error={errors.team_Lead_Margin_Team_Expenses_Percentage?.message} />
                            {/* <JVInput required type="number" column={3} label="Team Lead Margin Dollar per lakh (in number only)" control={control} name="team_Lead_Margin_Dollar" error={errors.team_Lead_Margin_Dollar?.message} /> */}
                            {/* <JVInput required type="number" column={3} label="Team Lead Months Margin Calculation (in number only) (It will consider from previous months, if months count is 2 then it will consider current months previous month and ( previous month of current months previous month ) )" control={control} name="team_Lead_Margin_Cal_Months" error={errors.team_Lead_Margin_Cal_Months?.message} /> */}
                        </div>
                    </AccordionTab>
                </Accordion>
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                {/* <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6 h-2rem " label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div> */}
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
